export default {
  'zh-CN': {
    tracking: {
      tracking: '自助查询',
      destination: '路向选择',
      service: '服务选择',
      packageSpicifications: '具体限制',
      weightLimit: '重量限制：',
      dimensionLimit: '尺寸限制：',
      valueTerms: '货值限额及贸易条款：',
      note: '注：',
      default: {
        state: '请选择洲',
        country: '请选择国家'
      },
      ShipmentTracking: '运单查询',
      Contact: '联系我们',
      FromMainland:"中国大陆出口",
      FromHK:"中国香港出口",
      PickServiceCoverage: '全国揽收范围查询',
      ProductsPricing: '价格/时效查询',
      PackageSpecifications: '重量/尺寸/货值限制查询',
      Contrabands: '禁运产品查询',
      //  tracking02
      SearchGlobal: '查询全国范围所有揽收网点地址及电话等详细信息',
      SelfDeliver: '自送',
      Pickup: '揽收',
      //  tracking03
      SearchPrice: '可查询订单运送的价格及预计到达时间',
      SpeedPAK: '海外直邮服务',
      ConsolFreight: '海外仓头程服务',
      ConsolFreight2: '海外仓头程服务东南亚版',
      //  tracking04
      SearchSize: '可查询货物的重量、尺寸、货值的限制',
      //  tracking05
      SearchProhibited: '查询所到达国家的相关禁运规定物品',
      More: '了解详情',
      //product
      SpeedPAKIntr: '海外直邮服务介绍',
      warehouseIntr: '海外仓头程服务介绍',
      financeIntr: '金融服务介绍',
      multiChannelService:'Multi-Channel服务',
      multiChannelIntr:'Multi-Channel服务介绍',
      tracking03: {
        dlPriceCard: '中国大陆始发价卡下载',
        dlMiniPriceCard: '中国大陆MiNi始发价卡下载',
        hkPriceCard: '中国香港始发价卡下载',
        spkPriceCalculator: 'SpeedPAK价格计算器',
        spfPriceCard:'SPF中国始发价卡下载',
        spfAsiaPriceCard:'SPF东南亚始发价卡下载',
        list: {
          cn: '中国大陆',
          hk: '中国香港',
          yes: '是',
          no: '否'
        },
        spkPriceCalculate:{
          departureList2:[{key: '中国大陆',value: 'CN'},{key: '中国香港',value: 'HK'}],
          tip:{
            remin:'温馨提醒',
            tip1:'运费以实际扣费为准，列表内展示的计算结果仅供参考',
            tip2:'产品计费标准详见页面下方【计费标准】说明',
            tip2Prefix:'产品计费标准详见页面下方',
            tip2Middle:'【计费标准】',
            tip2Suffix:'说明',
            tip3Prefix:'各路向包裹重量/尺寸/货值限制详情可通过',
            tip3Middle:'【重量/尺寸/货值限制查询】',
            tip3Suffix:'查询',
            toolTip1: '-若包裹所有单边<40cm，计费重=实际核重（以下简称实重）；',
            toolTip2: '-若包裹任意单边≥40cm，且体积重≤【实重*130%】，计费重=实重；举例1，包裹单边≥40cm，实重100g，体积重120g，则计费重为100g；',
            toolTip3: '-若包裹任意单边≥40cm，且体积重>【实重*130%】，将额外收取超过实重30%以上的抛重部分，即计费重=【实重+（体积重-实重*130%）】；举例2，包裹单边≥40cm，实重100g，体积重200g，则计费重=100+（200-100*130%）=170g；',
            toolTip4: '备注：体积重=【长(cm)*宽(cm)*高(cm)/6000】，单位kg',
            toolTip5:'SeedPAK标准，经济服务（除墨西哥标准，特货经济服务）；',
            toolTip6:'墨西哥标准，特货经济标准：',
            toolTip7:'按1:6000计泡系数计算体积重，体积重和实际重量大的为计费重',
            toolTip8:'-若包裹体积≤实重，计费重=实重；举例1，包裹实重120g，体积重100g，则计费重为120g；',
            toolTip9:'-若包裹体积>实重，计费重=体积重；举例2，包裹实重100g，体积重200g，则计费重=200g；',
          },
          calBtnText:'计算',
          calReset:'重置',
          gridData:{
            total: '总费用',
            current: '当前价卡运费',
            result: '计算结果',
            noResult: '暂无计算结果',
            title: 'SpeedPAK价格计算器',
            remark:'备注',
            chareType_actual:'实重',
            chareType_weighting:'计抛重',
          },
          prompt:{
            destination:'请选择目的国',
            weight:'请输入重量',
            product:'请选择产品',
            project:'请选择项目和产品',
            zipCode:'请输入邮编',
          },
          conditions:{
            departure:'始发地',
            destination:'目的地',
            orderTime:'寄件时间',
            charged:'是否带电',
            incoterm:'贸易方式',
            weight:'重量(g)',
            calWeight:'计费重量',
            product:'产品',
            length:'长(cm)',
            width:'宽(cm)',
            height:'高(cm)',
            productInners:'内部产品',
            project:'项目名称',
            zipCode:'目的区域邮编',
            addressValidation:'地址api校验',
            letter:'是否过模具',
            productOuter: '外部产品',
            productInner: '内部产品',
            calWeight130: '实际重*130%',
            volumeWeight: '体积重',
            chargeType: '计费方式',
            freight: '运费',
            handlingCharges: '处理费',
            channelCode:'关联渠道'
          },
          alert:{
            notNull:'该项为必填项',
            invalid:'输入值不合法',
            decimalRange0to4:'0到4位小数',
            checkAllRequired:'请填写所有带*必填项',
            notZero:'输入值不能为0',
            calcuNull:'价格计算失败，请检查包裹的重量或尺寸信息是否超出所选目的国的限制'
          },
        }

      },
      contactTime: '工作时间：周一至周六 9:00-18:00（节假日除外）',
      contactPhoneTitle: '客服中心电话：',
      contactPhone1: '400 126 0008（中国大陆)',
      contactPhone2: '852 30183458（香港地区)',
      contactEmail: '客服中心邮箱：CS@orangeconnex.com',
      contactWeChat: '微信公众号：橙联中国',
      miniContactPhone1: '中国大陆：400 126 0008',
      miniContactPhone2: '香港地区：852 30183458',
      miniContactEmailTitle: '客服中心邮箱',
      miniContactEmail: 'CS@orangeconnex.com',
      From: "始发地",
      To: "目的地",
      DateDesc: "日期",
      ActivityDesc: "包裹状态",
      LocationDesc: "地点"


    }
  },
  'en-US': {
    tracking: {
      tracking: 'Tracking',
      destination: 'Destination',
      service: 'Service',
      packageSpicifications: 'Package Spicifications',
      weightLimit: 'Weight Limit：',
      dimensionLimit: 'Dimension Limited：',
      valueTerms: 'Cargo value limit and Incoterm：',
      note: 'Remarks：',
      default: {
        state: 'State',
        country: 'Country'
      },
      Contact: 'Contact Us',
      FromMainland:"From Mainland,CN",
      FromHK:"From HK,CN",
      ShipmentTracking: 'Shipment Tracking',
      PickServiceCoverage: 'Pick-up Service Coverage',
      ProductsPricing: 'Products and Pricing',
      PackageSpecifications: 'Package Specifications',
      Contrabands: 'Contrabands',
      // tracking02
      SearchGlobal: 'Search for specific stations/areas including contact information',
      SelfDeliver: 'Self-Deliver',
      Pickup: 'Pickup',
      //  tracking03
      SearchPrice: 'Search for specific product information such as pricing, and delivery time',
      SpeedPAK: 'SpeedPAK',
      ConsolFreight: 'Speed Freight',
      ConsolFreight2: 'Speed Freight Service</br> (Southeast Asia)',
      //  tracking04
      SearchSize: 'Search for package specifications such as limitations in size, weights, and value',
      //  tracking05
      SearchProhibited: 'Search for specific contrabands in our designated countries',
      More: 'Search',
      //product
      SpeedPAKIntr: 'Direct Mail',
      warehouseIntr: 'Speed Freight',
      financeIntr: 'Financial Product',
      multiChannelService:'Multi-Channel',
      multiChannelIntr:'Multi-Channel',
      tracking03: {
        dlPriceCard: 'Rate Card Download (CN)',
        dlMiniPriceCard: 'MiNi Rate Card Download (CN)',
        hkPriceCard: 'Rate Card Download (HK)',
        spkPriceCalculator: 'SpeedPAK Shipping Calculator',
        spfPriceCard:'SPF Rate Card Download (CN）',
        spfAsiaPriceCard:'SPF Rate Card Download </br>(Southeast Asia)',
        list: {
          cn: 'Chinese Mainland',
          hk: 'Hong Kong, China',
          yes: 'YES',
          no: 'NO'
        },
        spkPriceCalculate:{
          departureList2:[{key: 'Chinese Mainland',value: 'CN'},{key: 'Hong Kong, China',value: 'HK'}],
          tip:{
            remin:'Reminder',
            tip1:'The calculation result is for reference only, the final rate is subjected to the amount on the bill.',
            tip2:'the Bill standard please refer to below 【Billing standard】 explaination',
            tip2Prefix:'For more information on',
            tip2Middle:'【Service Price】',
            tip2Suffix:' , please refer to the following description',
            tip3Prefix:'For weight/dimension information of the destination country, please refer to',
            tip3Middle:'【Package Specifications】',
            tip3Suffix:'',
            toolTip1: '· If Parcel Length And Width And Height <40cm, Chargeable Weight = Gross Weight;',
            toolTip2: '· If Parcel Length Or Width Or Height≥40cm, And Volumetric Weight ≤【Gross Weight * 130%】, Chargeable Weight = Gross Weight; Example 1, Gross Weight Is 100g, Volumetric Weight Is 120g, Then Chargeable Weight Is 100g;',
            toolTip3: '· If Parcel Length Or Width Or Height≥40cm, And Volumetric Weight >【Gross Weight * 130%】, It Will Be Charged With Additional Volumetric Weight Of Those 30% Higher Part, Chargeable Weight = 【Gross Weight + (Volumetric Weight - Gross Weight * 130%)】; Example 2, Gross Weight Is 100g, Volumetric Weight Is 200g, Then Chargeable Weight =100+(200-100*130%)=170g;',
            toolTip4: 'REMARK: Volumetric Weight =【Length (Cm)*Width (Cm)*Height(Cm)/6000】, Weight Unit Is Kg.',
            toolTip5:'SeedPAK Standard and Economy service ：（Except Mexico Standard & Special goods economy service）',
            toolTip6:'Mexico Standard & Special goods economy service',
            toolTip7:'Volumetric weight is calculated according to 1：6000, the chargeable weight is equal to volumetric weight or gross weight, which is greater',
            toolTip8:'-If parcel volumetric weight ≤ gross weight, chargeable weight = gross weight; Example 1, gross weight is 120g, volumetric weight is 100g, then chargeable weight is 120g; ',
            toolTip9:'-If parcel volumetric weight >gross weight, chargeable weight = volumetric weight; Example 2, gross weight is 100g, volumetric weight is 200g, then chargeable weight =200g;',
          },
          calBtnText:'Calculation',
          calReset:'Reset',
          gridData:{
            total:'Total Cost',
            current:'Current price-card freight',
            result:'Calculation result',
            noResult: 'Without calculation result',
            title: 'SpeedPAK Price Calculator',
            remark:'Remark',
            chareType_actual:'actual weight',
            chareType_weighting:'Weighting',

          },
          prompt:{
            destination:'Please select the destination',
            weight:'Please input weight',
            product:'Please select product',
            project:'Please select project and product',
            zipCode:'Please input zip codes'
          },
          conditions:{
            departure:'Departure',
            destination:'Destination',
            orderTime:'Shipping time',
            charged:'Battery',
            incoterm:'Type Of Trade',
            weight:'Weight',
            calWeight:'Billing weight',
            product:'Product',
            length:'Length',
            width:'Width',
            height:'Height',
            productInners:'inner product',
            project:'Project name',
            zipCode:'Destination area zip code',
            addressValidation:'Address valildateion',
            letter:'Is letter',
            productOuter: 'product outer',
            productInner: 'Product inner',
            calWeight130: 'actualWeight*130%',
            volumeWeight: 'volumeWeight',
            chargeType: 'chargeType',
            freight: 'Freight',
            handlingCharges: 'Handling charges',
            channelCode:'Associated channels'
          },
          alert:{
            notNull:'This condition is required',
            invalid:'Input value is illegal',
            decimalRange0to4:'0 to 4 decimal places',
            checkAllRequired:'Please input all required conditions with a red *',
            notZero:'Input value can not be 0',
            calcuNull: 'Price calculation failed. Please check if the package weight or dimension information exceeds the limit of the destination country'
          },
        }
      },
      contactTime: 'Business hours：Monday-Saturday 9:00-18:00 (National Holidays not included.)',
      contactPhoneTitle: '',
      contactPhone1: 'Tel：400 126 0008（China mainland)/ 852 30183458(HKSAR)',
      contactPhone2: '',
      contactEmail: 'E-Mail：CS@orangeconnex.com',
      contactWeChat: 'WeChat：橙联中国',
      miniContactPhone1: 'Tel：400 126 0008（China mainland)',
      miniContactPhone2: 'Tel：852 30183458(HKSAR)',
      miniContactEmailTitle: '',
      miniContactEmail: 'E-Mail：CS@orangeconnex.com',
      From: "From",
      To: "To",
      DateDesc: "Date",
      ActivityDesc: "Activity",
      LocationDesc: "Location"
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/Tracking_local.js